import {
  ApiPlatformAdminDataProvider,
  hydraDataProvider as baseHydraDataProvider,
} from '@api-platform/admin';
import { API_PATH } from 'config/entrypoint';

import { apiDocumentationParser } from './apiDocParser';
import { fetchHydra } from './httpClient';

export const dataProvider: ApiPlatformAdminDataProvider = baseHydraDataProvider({
  entrypoint: API_PATH,
  httpClient: fetchHydra,
  apiDocumentationParser: apiDocumentationParser,
  mercure: false,
  useEmbedded: true,
});
